<div class='proposal'>
    <button (click)="closeBtnClick()" class="closeBtn">x</button>
    <img src="assets/images/message-send.svg" alt="message">
    <p class='proposal-sent'>Intro Proposal(s) Sent Successfully</p>
    <p class='proposal-txt'>We have also sent you an email with the details</p>
    <button (click)="closeBtnClick()" class="cancel">Close</button>
</div>
